import { useMutation } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';

type TotpSetupResponse = {
  secret: string;
  otpauthUrl?: string;
};

const setupTotp = async (userId: string): Promise<TotpSetupResponse> => {
  const { data } = await customAxios.post<TotpSetupResponse>(
    `/users/${userId}/mfa/totp/setup`
  );
  return data;
};

export const useSetupTotp = () =>
  useMutation({
    mutationFn: setupTotp,
  });
